import { PermissionT } from "../types";

export const canSubmitProposal = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "proposal_creation");
  return !!p;
};

export default canSubmitProposal;
